import { c as _c } from "react/compiler-runtime";
import { Hint, useCustomToasts, PrimaryButton } from '@systemeio/ui';
import { AddIcon } from '@systemeio/ui/icons';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import SettingsSectionHeading from 'modules/profile/components/settings-section-heading';
import TransLoco from 'shared/components/trans-loco';
import { InfoBlockOrderedListItem } from 'shared/components/info-block-ordered-list-item';
import { Table } from 'shared/components/table/table';
import React, { useState } from 'react';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { KeyTypeEnum, McpSettingsCreatedInterface, McpSettingsViewInterface } from 'modules/profile/public-api-settings/types/public-api-settings-interface';
import { CopyToClipboardButton } from 'shared/components/copy-to-clipboard-button';
import { StatusCell } from 'shared/components/table/cells/status-cell';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import useUser from 'shared/hooks/use-user';
import { usePublicKeys } from 'modules/profile/public-api-settings/hooks/use-public-keys';
import { useDeleteKey } from 'modules/profile/public-api-settings/hooks/use-delete-key';
import CreateModal from 'shared/components/create-modal';
import { useCreateDataMcpKeys } from 'modules/profile/public-api-settings/hooks/use-create-data-mcp-keys';
export const McpKeys = () => {
  const $ = _c(118);
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [newCreatedKeys, setNewCreatedKeys] = useState(t0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    mutateMCPKeys,
    mcpKeys
  } = usePublicKeys();
  const {
    deleteKey
  } = useDeleteKey();
  const {
    infoToast
  } = useCustomToasts();
  let t1;
  if ($[1] !== infoToast || $[2] !== mutateMCPKeys || $[3] !== t) {
    t1 = {
      onCreate: async createdKey => {
        await mutateMCPKeys(data => data && [...data, {
          id: createdKey.id,
          name: createdKey.name,
          createdAt: createdKey.createdAt,
          expiresAt: createdKey.expiresAt,
          maskedToken: createdKey.token,
          expired: false,
          type: KeyTypeEnum.Mcp
        }], false);
        setNewCreatedKeys(prev => [...prev, {
          id: createdKey.id,
          token: createdKey.token
        }]);
        infoToast(t("dashboard.user_settings.public_api.copy_reminder"));
      }
    };
    $[1] = infoToast;
    $[2] = mutateMCPKeys;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    createData,
    isFetchingMcpKey
  } = useCreateDataMcpKeys(t1);
  let t2;
  if ($[5] !== deleteKey || $[6] !== mutateMCPKeys) {
    t2 = async deletedItem => {
      await deleteKey(deletedItem.id);
      await mutateMCPKeys(data_0 => data_0 && data_0?.filter(t3 => {
        const {
          id
        } = t3;
        return id !== deletedItem.id;
      }), false);
      setNewCreatedKeys(prev_0 => prev_0.filter(token => token.id !== deletedItem.id));
    };
    $[5] = deleteKey;
    $[6] = mutateMCPKeys;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onDeletePublicApiKeys = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      a: <a className="primary-link" target="_blank" rel="noreferrer" href="https://mcp.systeme.io" />
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  let t5;
  if ($[9] !== t) {
    t4 = <TransLoco t={t} i18nKey="dashboard.user_settings.public_api.mcp_name_tooltip" components={t3} />;
    t5 = t("dashboard.user_settings.public_api.name");
    $[9] = t;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = {
      key: "name",
      header: <Hint label={t4}>{t5}</Hint>,
      widthPercent: 20
    };
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("dashboard.user_settings.public_api.token_tooltip");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("dashboard.user_settings.public_api.token");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <Hint label={t7}>{t8}</Hint>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== newCreatedKeys) {
    t10 = t11 => {
      const {
        id: id_0,
        maskedToken
      } = t11;
      const newCreatedKey = newCreatedKeys.find(key => key.id === id_0)?.token;
      return newCreatedKey ? <div className="flex gap-2"><CopyToClipboardButton text={newCreatedKey} className="shrink-0" /><p className="truncate text-sm">{newCreatedKey}</p></div> : <p className="truncate text-sm">{maskedToken}</p>;
    };
    $[22] = newCreatedKeys;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t9) {
    t11 = {
      key: "maskedToken",
      header: t9,
      widthPercent: 50,
      onRender: t10
    };
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t) {
    t12 = t("global.status");
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12) {
    t13 = {
      key: "status",
      header: t12,
      widthPercent: 10,
      onRender: _temp
    };
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t) {
    t14 = t("dashboard.user_settings.public_api.expires_at");
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t || $[34] !== user?.dateFormat || $[35] !== user?.timeFormat || $[36] !== user?.timezone) {
    t15 = t16 => {
      const {
        expiresAt
      } = t16;
      return expiresAt === null ? t("dashboard.user_settings.public_api.expires_at_never") : dateTimeFormat(expiresAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      });
    };
    $[33] = t;
    $[34] = user?.dateFormat;
    $[35] = user?.timeFormat;
    $[36] = user?.timezone;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t14 || $[39] !== t15) {
    t16 = {
      key: "expiresAt",
      header: t14,
      widthPercent: 20,
      onRender: t15
    };
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t11 || $[42] !== t13 || $[43] !== t16 || $[44] !== t6) {
    t17 = [t6, t11, t13, t16];
    $[41] = t11;
    $[42] = t13;
    $[43] = t16;
    $[44] = t6;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  const columns = t17;
  let t18;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      a: <a className="primary-link" target="_blank" rel="noreferrer" href="https://developer.systeme.io/docs/mcp-server" />
    };
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  let t20;
  if ($[47] !== t) {
    t19 = <TransLoco t={t} i18nKey="dashboard.user_settings.public_api.mcp_title_tooltip" components={t18} />;
    t20 = t("dashboard.user_settings.public_api.mcp_title");
    $[47] = t;
    $[48] = t19;
    $[49] = t20;
  } else {
    t19 = $[48];
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t20) {
    t21 = <h3>{t20}</h3>;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== t19 || $[53] !== t21) {
    t22 = <SettingsSectionHeading><Hint label={t19}>{t21}</Hint></SettingsSectionHeading>;
    $[52] = t19;
    $[53] = t21;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== t) {
    t23 = t("dashboard.user_settings.public_api.mcp_instruction_title");
    $[55] = t;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== t23) {
    t24 = <h4 className="text-text-primary text-[16px] font-bold leading-6">{t23}</h4>;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== t) {
    t25 = t("dashboard.user_settings.public_api.mcp_instruction_first");
    $[59] = t;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== t25) {
    t26 = <InfoBlockOrderedListItem wrapperClassName="items-center">{t25}</InfoBlockOrderedListItem>;
    $[61] = t25;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== t) {
    t27 = t("dashboard.user_settings.public_api.mcp_instruction_second");
    $[63] = t;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== t27) {
    t28 = <InfoBlockOrderedListItem wrapperClassName="items-center">{t27}</InfoBlockOrderedListItem>;
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== t26 || $[68] !== t28) {
    t29 = <ul className="flex flex-col gap-6">{t26}{t28}</ul>;
    $[67] = t26;
    $[68] = t28;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  let t30;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      b: <b />
    };
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  let t31;
  if ($[71] !== t) {
    t31 = <p><span><TransLoco t={t} i18nKey="dashboard.user_settings.public_api.mcp_instruction_warning" components={t30} /></span></p>;
    $[71] = t;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== t22 || $[74] !== t24 || $[75] !== t29 || $[76] !== t31) {
    t32 = <div className={"flex h-fit flex-col gap-6\n          xl:col-start-2 xl:row-start-1 xl:row-end-7"}>{t22}{t24}{t29}{t31}</div>;
    $[73] = t22;
    $[74] = t24;
    $[75] = t29;
    $[76] = t31;
    $[77] = t32;
  } else {
    t32 = $[77];
  }
  let t33;
  if ($[78] !== t) {
    t33 = t("dashboard.user_settings.public_api.mcp_caption");
    $[78] = t;
    $[79] = t33;
  } else {
    t33 = $[79];
  }
  let t34;
  if ($[80] !== onDeletePublicApiKeys) {
    t34 = {
      remove: {
        onChange: onDeletePublicApiKeys
      }
    };
    $[80] = onDeletePublicApiKeys;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  let t35;
  if ($[82] !== mcpKeys) {
    t35 = mcpKeys && {
      hasMore: false,
      items: mcpKeys
    };
    $[82] = mcpKeys;
    $[83] = t35;
  } else {
    t35 = $[83];
  }
  let t36;
  if ($[84] !== columns || $[85] !== t33 || $[86] !== t34 || $[87] !== t35) {
    t36 = <Table caption={t33} actions={t34} data={t35} columns={columns} emptyListWithTitles={true} />;
    $[84] = columns;
    $[85] = t33;
    $[86] = t34;
    $[87] = t35;
    $[88] = t36;
  } else {
    t36 = $[88];
  }
  const t37 = createData.disabled || !mcpKeys;
  let t38;
  if ($[89] !== createData) {
    t38 = () => {
      if (createData.onOpen) {
        createData.onOpen().then(() => {
          setIsModalOpen(true);
        });
      } else {
        setIsModalOpen(true);
      }
    };
    $[89] = createData;
    $[90] = t38;
  } else {
    t38 = $[90];
  }
  const t39 = createData.testAttributePostfix;
  let t40;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <AddIcon />;
    $[91] = t40;
  } else {
    t40 = $[91];
  }
  let t41;
  if ($[92] !== t) {
    t41 = t("global.create");
    $[92] = t;
    $[93] = t41;
  } else {
    t41 = $[93];
  }
  let t42;
  if ($[94] !== t41) {
    t42 = <span> {t41}</span>;
    $[94] = t41;
    $[95] = t42;
  } else {
    t42 = $[95];
  }
  let t43;
  if ($[96] !== createData.testAttributePostfix || $[97] !== isFetchingMcpKey || $[98] !== t37 || $[99] !== t38 || $[100] !== t42) {
    t43 = <PrimaryButton disabled={t37} onClick={t38} isFetching={isFetchingMcpKey} className="flex" testAttributePostfix={t39}>{t40}{t42}</PrimaryButton>;
    $[96] = createData.testAttributePostfix;
    $[97] = isFetchingMcpKey;
    $[98] = t37;
    $[99] = t38;
    $[100] = t42;
    $[101] = t43;
  } else {
    t43 = $[101];
  }
  let t44;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = () => {
      setIsModalOpen(false);
    };
    $[102] = t44;
  } else {
    t44 = $[102];
  }
  let t45;
  if ($[103] !== createData) {
    t45 = data_1 => createData.onCreate(data_1);
    $[103] = createData;
    $[104] = t45;
  } else {
    t45 = $[104];
  }
  let t46;
  if ($[105] !== createData || $[106] !== isModalOpen || $[107] !== t45) {
    t46 = <CreateModal opened={isModalOpen} onClose={t44} afterLeave={createData.onAfterLeave} {...createData} onCreate={t45} />;
    $[105] = createData;
    $[106] = isModalOpen;
    $[107] = t45;
    $[108] = t46;
  } else {
    t46 = $[108];
  }
  let t47;
  if ($[109] !== t43 || $[110] !== t46) {
    t47 = <div className="my-4 flex justify-center">{t43}{t46}</div>;
    $[109] = t43;
    $[110] = t46;
    $[111] = t47;
  } else {
    t47 = $[111];
  }
  let t48;
  if ($[112] !== t36 || $[113] !== t47) {
    t48 = <div className="bg-background-secondary border-text-secondary/30 mt-5 h-fit w-full min-w-0 rounded-lg border">{t36}{t47}</div>;
    $[112] = t36;
    $[113] = t47;
    $[114] = t48;
  } else {
    t48 = $[114];
  }
  let t49;
  if ($[115] !== t32 || $[116] !== t48) {
    t49 = <div className="pt-6">{t32}{t48}</div>;
    $[115] = t32;
    $[116] = t48;
    $[117] = t49;
  } else {
    t49 = $[117];
  }
  return t49;
};
function _temp(t0) {
  const {
    expired
  } = t0;
  return <div className="flex justify-center gap-2"><StatusCell isActive={!expired} className="shrink-0" /></div>;
}